import { z } from 'zod';

export const App = z.enum(['aim', 'platform', 'chat', 'psf']);
export type App = z.infer<typeof App>;
